import React from "react";

const Usage = () => {
  return <div>this is the usage page</div>;
};

export default Usage;
